/*分驾驶舱功能相关路由*/

/*驾驶舱*/
import gxsfb_cockpit_modules from "./gxsfb/gxsfb_cockpit_page"; /*供应商分布驾驶舱*/
import khfb_cockpit_modules from "./khfb/khfb_cockpit_page"; /*客户分布驾驶舱*/
import wlwyzt_cockpit_modules from "./wlwyzt/wlwyzt_cockpit_page"; /*物联网一张图驾驶舱*/
import nqjcyzt_cockpit_modules from "./nqjcyzt/nqjcyzt_cockpit_page";
export default [
  ...gxsfb_cockpit_modules /*供应商分布驾驶舱*/,
  ...khfb_cockpit_modules /*客户分布驾驶舱*/,
  ...wlwyzt_cockpit_modules /*物联网一张图驾驶舱*/,
  ...nqjcyzt_cockpit_modules /**农情监测一张图 */
];



// WEBPACK FOOTER //
// ./src/router/modules/part_cockpit_page.js